import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { PLAN_OVERVIEW_KEY } from './useGetPlanOverview'
import { OPERATOR_PROFILE_KEY } from './useGetProfile'

type WorkforceProfilePayload = {
  operatorIds: string[]
  isFullTime?: boolean
  isWorkforceManaged?: boolean
}

export function useUpdateWorkforceProfile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: WorkforceProfilePayload) => {
      await apiClient.patch('/int/v3/operators/workforce-profile', payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PLAN_OVERVIEW_KEY] })
      queryClient.invalidateQueries({ queryKey: [OPERATOR_PROFILE_KEY] })
    },
  })
}
